/**
 * Practice tracks that are announced but not open yet.
 * Signed-in visitors who open one of these routes see a "coming soon" popup
 * (see components/coming-soon). To launch a track, delete its entry here.
 */
export interface ComingSoonTopic {
  /** Route slug, also used to pick the icon in the dialog. */
  slug: string;
  /** Exact pathname that triggers the popup. */
  path: string;
  name: string;
  /** One short sentence under the title. */
  summary: string;
  /** What learners can expect, 3 short bullets. */
  expect: string[];
}

export const COMING_SOON_TOPICS: readonly ComingSoonTopic[] = [
  {
    slug: "cypress",
    path: "/cypress",
    name: "Cypress",
    summary: "Hands-on Cypress practice is being finished and will open here soon.",
    expect: [
      "Reliable command chains and retry-ability",
      "API interception with cy.intercept",
      "Custom commands and component testing",
    ],
  },
  {
    slug: "ai-testing",
    path: "/ai-testing",
    name: "AI Testing",
    summary: "Practice for testing LLM and ML-powered features is being finished and will open here soon.",
    expect: [
      "Prompt and output validation",
      "Evals, grounding and non-determinism",
      "Safety and bias checks",
    ],
  },
];

function normalize(pathname: string): string {
  const trimmed = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return trimmed.toLowerCase();
}

/** Returns the coming-soon topic for an exact route, or null for every other route. */
export function findComingSoonTopic(pathname: string): ComingSoonTopic | null {
  const path = normalize(pathname);
  return COMING_SOON_TOPICS.find((topic) => topic.path === path) ?? null;
}
